
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["connectPricerWS","sendEvent","closeWS"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "252ed50bbbfaa44d37bf.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "252ed50bbbfaa44d37bf.worker.js");
					addMethods(w, methods)
					
					return w
				}
			